export enum LabelBadge16Type {
  WUF = 'WUF',
  solid = 'solid',
  line = 'line',
  badge = 'badge',
  yellow = 'yellow',
  violet = 'violet',
  red = 'red',
  black = 'black',
}
